window.onload = (event) => {
    const sections = document.querySelectorAll(".coll_row");
    const navLi = document.querySelectorAll(".sidebar ul li");
    window.onscroll = () => {
      var current = "";    
      sections.forEach((section) => {    
        const sectionTop = section.offsetTop;   
        if (window.pageYOffset >= sectionTop - 120) {
          current = section.getAttribute("data-collection"); }
      });
    
      navLi.forEach((li) => {
        li.classList.remove("active");
        if (li.getAttribute("data-target") == current) {
          li.classList.add("active");
        }
      });
    };
};